import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

export default function Dashboard() {
  const [quizzes, setQuizzes] = useState([]);

  useEffect(() => {
    fetch("https://yesedacademy.com/database/quiz.php?action=list")
      .then((res) => res.json())
      .then(setQuizzes);
  }, []);

  return (
    <div className="min-h-screen bg-gray-100 p-6">
      <div className="max-w-5xl mx-auto">
        {/* Header */}
        <div className="flex justify-between items-center mb-6">
          <h1 className="text-3xl font-bold text-gray-800">📊 Quiz Dashboard</h1>
          <Link to="/create_quiz">
            <button className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-4 rounded shadow">
              ➕ Create New Quiz
            </button>
          </Link>
        </div>

        {/* Quiz List */}
        {quizzes.length === 0 ? (
          <p className="text-gray-500">No quizzes available. Create one to get started!</p>
        ) : (
          <div className="grid gap-6 md:grid-cols-2">
            {quizzes.map((quiz) => (
              <div
                key={quiz.id}
                className="bg-white rounded-xl shadow p-5 hover:shadow-md transition-all"
              >
                <h2 className="text-xl font-bold text-gray-800 mb-2">{quiz.title}</h2>
                <p className="text-sm text-gray-500 mb-4 capitalize">
                  Display Mode: {quiz.display_mode}
                </p>
                <Link to={`/quiz/${quiz.id}`}>
                  <button className="bg-green-600 hover:bg-green-700 text-white font-medium px-4 py-2 rounded">
                    ▶️ Take Quiz
                  </button>
                </Link>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
